import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';

import { Controls } from '../../../../components/controls/Controls';
import Dropdown from '../../../../components/controls/Dropdown';
import Form from '../../../../components/useForm';

import { useApiClient, convertAxiosErrorToUserFacingMessage } from '../../../../context/ApiClientContext';
import basicServiceHandler from '../../../../services/basicServiceHandler';
import useToast from '../../../../hooks/useToast';

export default function IncludeDxhxAdditionForm(props) {
  const {
    actionListId, onSuccess,
  } = props;
  const [dxhxs, setDxhxs] = useState([]);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [chosenDxhxId, setChosenDxhxId] = useState('');

  const {
    toastSetSuccessNotification,
    toastSetErrorNotification,
  } = useToast();

  const apiClient = useApiClient();

  useEffect(() => {
    basicServiceHandler(
      () => apiClient.getAllDxHx(),
      (result) => setDxhxs(result.data),
      () => toastSetErrorNotification('Unable to load dxhxs.'),
      () => {},
    );
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    setServiceLoading(true);
    basicServiceHandler(
      () => apiClient.addAddDxhxAction(actionListId, chosenDxhxId),
      () => {
        toastSetSuccessNotification('Successful!');
        if (onSuccess) {
          onSuccess();
        }
      },
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
      () => setServiceLoading(false),
    );
  };

  return (
    <Form onSubmit={handleAdd}>
      <Grid container>
        <Grid item xs={6}>
          <Dropdown
            label="Select a Dxhx to include"
            name="attributeValueId"
            value={chosenDxhxId}
            onChange={(e) => setChosenDxhxId(e.target.value)}
            options={dxhxs}
          />
          <Grid container justifyContent="flex-end">
            <Controls.Button
              variant="contained"
              type="submit"
              sx={{ margin: '6px' }}
              loading={serviceLoading}
              text="Include"
              size="medium"
            />
          </Grid>
        </Grid>
      </Grid>
    </Form>
  );
}

IncludeDxhxAdditionForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func,
};

IncludeDxhxAdditionForm.defaultProps = {
  onSuccess: null,
};
